import { RequestState } from "./../../../Types/Request";
import { Action, handleActions } from "redux-actions";

import { IPatchPayload } from "../../../components/course-author/helpers/patches";
import { IUsersUIData } from "../../../parsers/resolve";
import { IClass, ICourse } from "../../types/common";
import { IClassManagementAndUsers } from "../actions";
import * as actions from "../actions";

export interface IState {
  allCourses: ICourse[];
  allMembers: IUsersUIData[];
  allManagers: IUsersUIData[];
  classId: string | null;
  class: IClass | null;
  deleteClassStatus: RequestState;
  fetchStatus: RequestState;
  patchClassRequestStatus: RequestState;
  refreshStatus: RequestState;
}

export const INITIAL_STATE: IState = {
  allCourses: [],
  allManagers: [],
  allMembers: [],
  class: null,
  classId: null,
  deleteClassStatus: RequestState.IDLE,
  fetchStatus: RequestState.IDLE,
  patchClassRequestStatus: RequestState.IDLE,
  refreshStatus: RequestState.IDLE,
};

export function mount(_: IState, action: Action<string>): IState {
  return {
    ...INITIAL_STATE,
    classId: action.payload,
  };
}

export function unmount(_: IState, __: Action<void>): IState {
  return INITIAL_STATE;
}

export function fetchInitialData(state: IState, _: Action<void>): IState {
  return {
    ...state,
    allCourses: [],
    allManagers: [],
    allMembers: [],
    class: null,
    fetchStatus: RequestState.PENDING,
  };
}

export function handleFetchInitialDataFailure(state: IState, _: Action<{ message: string }>): IState {
  return {
    ...state,
    class: null,
    fetchStatus: RequestState.FAILED,
  };
}

export function handleFetchInitialDataSuccess(state: IState, { payload }: Action<actions.IInitialData>): IState {
  return {
    ...state,
    allCourses: payload.allCourses,
    allManagers: payload.allManagers,
    allMembers: payload.allMembers,
    class: payload.class,
    fetchStatus: RequestState.SUCCEEDED,
  };
}

export function patchClassRequest(state: IState, _: Action<IPatchPayload>): IState {
  return { ...state, patchClassRequestStatus: RequestState.PENDING };
}

export function patchClassRequestFailure(state: IState, _: Action<{ message: string }>): IState {
  return { ...state, patchClassRequestStatus: RequestState.FAILED };
}

export function patchClassRequestSuccess(state: IState, _: Action<void>): IState {
  return { ...state, patchClassRequestStatus: RequestState.SUCCEEDED };
}

export function refreshClass(state: IState, _: Action<void>): IState {
  return { ...state, refreshStatus: RequestState.PENDING };
}

export function refreshClassFailure(state: IState, _: Action<{ message: string }>): IState {
  return { ...state, refreshStatus: RequestState.FAILED };
}

export function refreshClassSuccess(state: IState, action: Action<IClassManagementAndUsers>): IState {
  return {
    ...state,
    allManagers: action.payload.allManagers,
    allMembers: action.payload.allMembers,
    class: action.payload.class,
    refreshStatus: RequestState.SUCCEEDED,
  };
}

const deleteClass = (state: IState, _: Action<void>) => ({
  ...state,
  deleteClassStatus: RequestState.PENDING,
});

const handleDeleteClassFailure = (state: IState, _: Action<{ message: string }>) => ({
  ...state,
  deleteClassStatus: RequestState.FAILED,
});

const handleDeleteClassSuccess = (state: IState, _: Action<void>) => ({
  ...state,
  class: null,
  classId: null,
  deleteClassStatus: RequestState.SUCCEEDED,
});

type IClassManagementPayload =
  | string
  | void
  | IClassManagementAndUsers
  | { message: string }
  | actions.IInitialData
  | IPatchPayload;

export const classManagementReducer = handleActions<IState, IClassManagementPayload>(
  {
    [actions.Action.MOUNT]: mount,
    [actions.Action.FETCH_INITIAL_DATA]: fetchInitialData,
    [actions.Action.HANDLE_FETCH_INITIAL_DATA_FAILURE]: handleFetchInitialDataFailure,
    [actions.Action.HANDLE_FETCH_INITIAL_DATA_SUCCESS]: handleFetchInitialDataSuccess,
    [actions.Action.DELETE_CLASS]: deleteClass,
    [actions.Action.HANDLE_DELETE_CLASS_FAILURE]: handleDeleteClassFailure,
    [actions.Action.HANDLE_DELETE_CLASS_SUCCESS]: handleDeleteClassSuccess,
    [actions.Action.PATCH_CLASS_REQUEST]: patchClassRequest,
    [actions.Action.PATCH_CLASS_REQUEST_FAILURE]: patchClassRequestFailure,
    [actions.Action.PATCH_CLASS_REQUEST_SUCCESS]: patchClassRequestSuccess,
    [actions.Action.REFRESH_CLASS]: refreshClass,
    [actions.Action.REFRESH_CLASS_FAILURE]: refreshClassFailure,
    [actions.Action.REFRESH_CLASS_SUCCESS]: refreshClassSuccess,
    [actions.Action.UNMOUNT]: unmount,
  },
  INITIAL_STATE
);
